import { BaseParser, DATA_TYPE_AOF } from './baseExtractor';

const iconAoFFile = 'AoI.png';

class AoFExtractor extends BaseParser {
  // eslint-disable-next-line no-unused-vars
  async _doParse(parent, fileName, data, report) {
    const returnValue = this.getNewReturnValue();
    const lines = data.split('\n');
    const outArray = [];
    for (let j = 0; j < lines.length; j++) {
      const splitLine = lines[j].split('\t');
      if (splitLine.length < 3) {
        returnValue.warnings.push(`The element in line ${j} could not be extracted`);
        continue;
      }
      const Xval = parseFloat(splitLine[1]);
      const concentration = parseFloat(splitLine[2]);
      if (!Number.isNaN(Xval) && !Number.isNaN(concentration)) {
        outArray.push([splitLine[0], Xval, concentration]);
      } else {
        returnValue.warnings.push(`The element in line ${j} could not be extracted. The values should be numbers`);
        continue;
      }
    }
    returnValue.processedData = outArray;
    returnValue.success = outArray.length > 0;
    if(returnValue.success)
      returnValue.lastError = '';
    returnValue.icon = iconAoFFile;
    returnValue.dataType = DATA_TYPE_AOF;
    return returnValue;
  }
}

export{
  AoFExtractor,
};